import { all } from 'redux-saga/effects';
import dashboard from './dashboard';
import filters from './filters';
import cityComparison from './cityComparison';

export default function* root() {
  yield all([dashboard(), cityComparison(), filters()]);
}
